// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#story-mode-marketing-budget[data-v-632130be]{margin-left:0}", ""]);
// Exports
module.exports = exports;
